import { Modal } from "components/ui/modals/Modal/Modal"
import { ButtonSecondary } from "components/ui/buttons/ButtonSecondary/ButtonSecondary"
import { ButtonWarning } from "components/ui/buttons/ButtonWarning/ButtonWarning"
import style from "./DeleteCompetitorModal.module.scss"

const { deleteCompetitorModal, description, buttonsWrapper } = style

type Props = {
	isModalOpen: boolean
	setModalClose: () => void
	title: string
	description: string
	cancelButtonText: string
	deleteButtonText: string
	onDelete: () => void
}

export const DeleteCompetitorModal = ({
	isModalOpen,
	setModalClose,
	title: modalTitle,
	description: modalDescription,
	cancelButtonText,
	deleteButtonText,
	onDelete,
}: Props) => {
	const handleDelete = () => {
		onDelete()
		setModalClose()
	}

	return (
		<Modal isModalOpen={isModalOpen} setModalClose={setModalClose} title={modalTitle}>
			<div className={deleteCompetitorModal}>
				<p className={description}>{modalDescription}</p>
				<div className={buttonsWrapper}>
					<ButtonSecondary onClick={setModalClose}>{cancelButtonText}</ButtonSecondary>
					<ButtonWarning onClick={handleDelete}>{deleteButtonText}</ButtonWarning>
				</div>
			</div>
		</Modal>
	)
}
